import urls from '../../Commons/urls'
import service from '../../Utils/service'
import { MICROSERVICES } from '../../Utils/constants'

export class ApplicationService {
  async getForms() {
    try {
      const response = await service.get(urls.getApiUrl('heatloan/application/get_forms', MICROSERVICES.HEATLOANMANAGER),)
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async submitApplication(params) {
    try {
      const response = await service.post(urls.getApiUrl('heatloan/application/submit', MICROSERVICES.HEATLOANMANAGER), params,
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const applicationService = new ApplicationService()
